import { render, staticRenderFns } from "./inspectorArrearsStatistics.vue?vue&type=template&id=6908d14b&scoped=true"
import script from "./inspectorArrearsStatistics.vue?vue&type=script&lang=js"
export * from "./inspectorArrearsStatistics.vue?vue&type=script&lang=js"
import style0 from "./inspectorArrearsStatistics.vue?vue&type=style&index=0&id=6908d14b&prod&scoped=true&lang=css"
import style1 from "./inspectorArrearsStatistics.vue?vue&type=style&index=1&id=6908d14b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6908d14b",
  null
  
)

export default component.exports